var _circle, _circle2, _path, _rect, _polygon, _polygon2, _polygon3, _circle3, _path2, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 1000,
    r: 814.301,
    fill: "#f8fcfe"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 1000,
    r: 675.841,
    fill: "#dfecfa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262f5f",
    d: "M1487.255,872.4529l-23.9679,148.6618-4.6007,28.5326c0,22.0918-47.1963,313.1189-71.6426,313.1189L1000.469,1095.6531,571.43379,1393.3284c-24.4373,0-50.1374-313.173-50.1374-335.2648l-1.705-36.9489-6.8467-148.2288,68.9726-59.6L972.8925,475.2517a47.99146,47.99146,0,0,1,55.153,0l390.8054,338.0342Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 758.383,
    height: 714.944,
    x: 622.838,
    y: 645.707,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#749dd3",
    points: "1000.525 1261.454 512.745 872.886 512.745 1533.462 1487.255 1533.462 1487.255 872.886 1000.525 1261.454"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9ebee5",
    points: "512.745 872.886 512.745 1533.462 927.364 1203.174 512.745 872.886"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9ebee5",
    points: "1487.255 872.886 1487.255 1533.462 1072.635 1203.174 1487.255 872.886"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1002.029,
    cy: 936.227,
    r: 137.366,
    fill: "#749dd3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262f5f",
    d: "M1002.0291,1116.1638c-99.21792,0-179.937-80.7195-179.937-179.9374s80.7191-179.9373,179.937-179.9373,179.9377,80.7195,179.9377,179.9373S1101.2469,1116.1638,1002.0291,1116.1638Zm0-339.5798c-88.02672,0-159.6421,71.6153-159.6421,159.6424s71.61538,159.6425,159.6421,159.6425c88.0275,0,159.6429-71.6154,159.6429-159.6425S1090.0566,776.584,1002.0291,776.584Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "981.626 1008.243 924.445 946.297 950.87 921.905 979.795 953.24 1051.626 864.21 1079.614 886.792 981.626 1008.243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verify-email.ceaeaa24c6fe8105365a3211b62a4375.svg";
export { ForwardRef as ReactComponent };